<template>
  <drag-wrap
    v-if="compVisible"
    :visible="compVisible"
    modalId="timer-modal"
    modalName="定时器"
  >
    <div
      class="timer-container"
      :class="{
        'timer-container_student': isStudent,
      }"
    >
      <!-- 标题栏 -->
      <div class="timer-header">
        <div class="title">定时器</div>
        <div class="close" @click="handleClose" v-if="!isStudent">
          <img src="@saas/pages/assets/images/live/close-1.png" alt="" />
        </div>
      </div>

      <!-- 时间显示区域 -->
      <div class="timer-content">
        <div class="time-display">
          <!-- 分钟十位 -->
          <div class="time-group">
            <div
              class="arrow-up"
              v-if="couldEdit"
              @click="handleIncrease('minutesTens')"
            ></div>
            <div class="time-box">
              <span class="time-number" :class="{ danger: isDanger }">{{
                formatNumber(displayMinutesTens)
              }}</span>
            </div>
            <div
              class="arrow-down"
              v-if="couldEdit"
              @click="handleDecrease('minutesTens')"
            ></div>
          </div>

          <!-- 分钟个位 -->
          <div class="time-group">
            <div
              class="arrow-up"
              v-if="couldEdit"
              @click="handleIncrease('minutesOnes')"
            ></div>
            <div class="time-box">
              <span class="time-number" :class="{ danger: isDanger }">{{
                formatNumber(displayMinutesOnes)
              }}</span>
            </div>
            <div
              class="arrow-down"
              v-if="couldEdit"
              @click="handleDecrease('minutesOnes')"
            ></div>
          </div>

          <!-- 分隔符 -->
          <div class="separator">
            <div class="dot"></div>
            <div class="dot"></div>
          </div>

          <!-- 秒数十位 -->
          <div class="time-group">
            <div
              class="arrow-up"
              v-if="couldEdit"
              @click="handleIncrease('secondsTens')"
            ></div>
            <div class="time-box">
              <span class="time-number" :class="{ danger: isDanger }">{{
                formatNumber(displaySecondsTens)
              }}</span>
            </div>
            <div
              class="arrow-down"
              v-if="couldEdit"
              @click="handleDecrease('secondsTens')"
            ></div>
          </div>

          <!-- 秒数个位 -->
          <div class="time-group">
            <div
              class="arrow-up"
              v-if="couldEdit"
              @click="handleIncrease('secondsOnes')"
            ></div>
            <div class="time-box">
              <span
                class="time-number"
                :class="{ warning: isLastDigitWarning, danger: isDanger }"
                >{{ formatNumber(displaySecondsOnes) }}</span
              >
            </div>
            <div
              class="arrow-down"
              v-if="couldEdit"
              @click="handleDecrease('secondsOnes')"
            ></div>
          </div>
        </div>
      </div>

      <!-- 底部按钮 -->
      <div class="timer-footer">
        <template v-if="!isStudent">
          <el-button
            v-if="!isRunning && !isPaused && !isFinished"
            type="primary"
            class="action-btn"
            :loading="startLoading"
            @click="handleStart"
          >
            开始
          </el-button>
          <el-button
            v-if="((isRunning || isPaused) && !isFinished) || isFinished"
            :type="isFinished ? 'primary' : 'default'"
            class="action-btn"
            :loading="restartLoading"
            @click="handleRestart"
          >
            重新开始
          </el-button>
          <el-button
            v-if="isRunning"
            type="primary"
            class="action-btn"
            :loading="pauseLoading"
            @click="handlePause"
          >
            暂停
          </el-button>
          <el-button
            v-if="isPaused"
            type="primary"
            class="action-btn"
            :loading="continueLoading"
            @click="handleContinue"
          >
            继续
          </el-button>
        </template>
        <template v-else>
          <div class="pause-tips">
            <span v-if="isPaused">定时器已暂停</span>
          </div>
        </template>
      </div>
    </div>
  </drag-wrap>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { DragWrap } from "@saas/components";
import {
  createTimer,
  endTimer,
  pauseTimer,
  getToolbox,
  startTimer,
} from "@saas/server-api/src/live-sdk";
import AccurateTimer from "./accurateTimer.js";
import ScreenShare from "../mixins/screen-share";
export default {
  mixins: [ScreenShare],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    toolboxStatus: {
      type: Object,
      default: () => ({
        isRunning: false,
        isPaused: false,
        timerId: null,
        remainingSeconds: 0,
        version: 0,
      }),
    },
  },
  components: {
    DragWrap,
  },
  data() {
    return {
      compVisible: false,
      // 时间显示
      minutesTens: 0,
      minutesOnes: 5,
      secondsTens: 0,
      secondsOnes: 0,
      // 状态
      isRunning: false,
      isPaused: false,
      isFinished: false,
      // 定时器
      timer: null,
      remainingSeconds: 300, // 默认5分钟
      // 精确计时器实例
      accurateTimer: null,
      // 当前定时器ID
      currentTimerId: null,
      // 版本号
      version: 0,
      // 闹铃音频
      alarmAudio: null,
      // 按钮加载状态
      startLoading: false,
      restartLoading: false,
      pauseLoading: false,
      continueLoading: false,
      // 结束时间戳
      endTimestamp: 0,
      // 同步定时器ID
      syncTimerId: null,
      // 上次同步时间
      lastSyncTime: 0,
    };
  },
  watch: {
    visible(val) {
      if (this.compVisible === val) {
        return;
      }
      this.compVisible = val;
      if (val) {
        this.initTimer();
      }
    },
    toolboxStatus: {
      handler(newStatus) {
        if (newStatus && this.compVisible) {
          // 如果工具箱状态变化，更新组件状态
          this.currentTimerId = newStatus.timerId;
          this.remainingSeconds =
            newStatus.remainingSeconds < 0 ? 0 : newStatus.remainingSeconds;

          this.isFinished = this.remainingSeconds === 0; // 重新进来时不是结束状态
          this.isRunning = this.isFinished ? false : newStatus.isRunning;
          this.isPaused = this.isFinished ? false : newStatus.isPaused;
          this.version = newStatus.version;
          if (this.isRunning) {
            this.startCountdown();
          }
        }
      },
      deep: true,
      immediate: true,
    },
    imService: {
      handler(val, oldVal) {
        if (val && !oldVal) {
          this.handleImListener();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.initAlarmAudio();
  },
  beforeDestroy() {
    this.clearTimer();
    this.stopAlarm();
    if (this.alarmAudio) {
      this.alarmAudio.pause();
      this.alarmAudio = null;
    }
    // 重置状态变量
    this.isRunning = false;
    this.isPaused = false;
    this.isFinished = false;
    this.remainingSeconds = 0;
    this.currentTimerId = null;
    this.version = 0;
    this.endTimestamp = 0; // 清理结束时间戳
    this.accurateTimer = null; // 清理精确计时器
    this.clearSyncTimer(); // 清理同步定时器
    // this.removeImListener();
  },
  computed: {
    ...mapState("live", [
      "liveService",
      "imService",
      "whiteBoardService",
      "roomInfo",
    ]),

    // 默认定时器时间（5分钟）
    defaultTimerSeconds() {
      return 300;
    },

    // 总秒数
    totalSeconds() {
      return (
        this.minutesTens * 600 +
        this.minutesOnes * 60 +
        this.secondsTens * 10 +
        this.secondsOnes
      );
    },

    // 当前显示的时间（倒计时时使用remainingSeconds，否则使用设置的时间）
    displayTime() {
      if (this.isRunning || this.isPaused || this.isFinished) {
        return this.remainingSeconds;
      }
      return this.totalSeconds;
    },

    // 显示的时间分解
    displayMinutesTens() {
      const minutes = Math.floor(this.displayTime / 60);
      return Math.floor(minutes / 10);
    },

    displayMinutesOnes() {
      const minutes = Math.floor(this.displayTime / 60);
      return minutes % 10;
    },

    displaySecondsTens() {
      const seconds = this.displayTime % 60;
      return Math.floor(seconds / 10);
    },

    displaySecondsOnes() {
      const seconds = this.displayTime % 60;
      return seconds % 10;
    },

    // 是否警告状态（小于10秒）
    isWarning() {
      return this.remainingSeconds <= 10 && this.remainingSeconds > 0;
    },

    // 是否危险状态（倒计时结束）
    isDanger() {
      return this.remainingSeconds === 0 && this.isFinished;
    },

    // 是否最后一个数字警告（小于等于9秒时只有最后一个数字变红色）
    isLastDigitWarning() {
      return (
        this.remainingSeconds <= 9 &&
        this.remainingSeconds > 0 &&
        (this.isRunning || this.isPaused)
      );
    },
    // 是否可以调整时间
    couldEdit() {
      return (
        !this.isRunning && !this.isPaused && !this.isFinished && !this.isStudent
      );
    },
    isStudent() {
      return !this.roomInfo.isTeacher && !this.roomInfo.isAssistant;
    },
  },
  methods: {
    ...mapMutations("live", ["setShowToolbox"]),
    // 初始化定时器
    initTimer() {
      // 先清除之前的状态
      this.clearTimer();
      this.stopAlarm();
      // 重置状态变量
      this.isRunning = false;
      this.isPaused = false;
      this.isFinished = false;
      this.remainingSeconds = 0;
      this.currentTimerId = null;
      this.version = 0;
      // 重置精确计时器
      this.accurateTimer = null;
      // 重置同步相关变量
      this.lastSyncTime = 0;

      // 从localStorage获取上次的定时时间，需要判断是否是当前直播间
      const currentRoomId = this.roomInfo.id;
      const lastTimerData = localStorage.getItem("lastTimerData");

      if (lastTimerData) {
        try {
          const data = JSON.parse(lastTimerData);
          // 检查是否是当前直播间的数据
          if (data.roomId === currentRoomId) {
            this.setTimeFromSeconds(data.timerSeconds);
          } else {
            // 不是当前直播间，使用默认值
            this.setTimeFromSeconds(this.defaultTimerSeconds);
          }
        } catch (error) {
          console.error("解析localStorage数据失败:", error);
          this.setTimeFromSeconds(this.defaultTimerSeconds);
        }
      } else {
        // 没有存储数据，使用默认值
        this.setTimeFromSeconds(this.defaultTimerSeconds);
      }
    },

    // 初始化闹铃音频
    initAlarmAudio() {
      this.alarmAudio = new Audio();
      this.alarmAudio.src =
        "https://cdn.moguocdn.com/cdn/static/audio/timeout.mp3"; // 需要添加闹铃音频文件
      this.alarmAudio.loop = false;
    },

    // 设置时间显示
    setTimeFromSeconds(seconds) {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;

      this.minutesTens = Math.floor(minutes / 10);
      this.minutesOnes = minutes % 10;
      this.secondsTens = Math.floor(remainingSeconds / 10);
      this.secondsOnes = remainingSeconds % 10;
    },

    // 格式化数字显示
    formatNumber(num) {
      return num.toString().padStart(1, "0");
    },

    // 保存定时器数据到localStorage（用于页面刷新时回显）
    saveTimerData() {
      const currentRoomId = this.roomInfo.id;
      const timerData = {
        roomId: currentRoomId,
        timerSeconds: this.totalSeconds,
      };
      localStorage.setItem("lastTimerData", JSON.stringify(timerData));
    },

    // 保存默认时间到localStorage
    saveDefaultTimerData() {
      const currentRoomId = this.roomInfo.id;
      const timerData = {
        roomId: currentRoomId,
        timerSeconds: this.defaultTimerSeconds,
      };
      localStorage.setItem("lastTimerData", JSON.stringify(timerData));
    },

    // 增加时间
    handleIncrease(type) {
      if (this.isRunning || this.isPaused) return;

      switch (type) {
        case "minutesTens":
          if (this.minutesTens < 5) this.minutesTens++;
          break;
        case "minutesOnes":
          if (this.minutesOnes < 9) this.minutesOnes++;
          else if (this.minutesTens < 5) {
            this.minutesOnes = 0;
            this.minutesTens++;
          }
          break;
        case "secondsTens":
          if (this.secondsTens < 5) this.secondsTens++;
          break;
        case "secondsOnes":
          if (this.secondsOnes < 9) this.secondsOnes++;
          else if (this.secondsTens < 5) {
            this.secondsOnes = 0;
            this.secondsTens++;
          }
          break;
      }
    },

    // 减少时间
    handleDecrease(type) {
      if (this.isRunning || this.isPaused) return;

      switch (type) {
        case "minutesTens":
          if (this.minutesTens > 0) this.minutesTens--;
          break;
        case "minutesOnes":
          if (this.minutesOnes > 0) this.minutesOnes--;
          else if (this.minutesTens > 0) {
            this.minutesOnes = 9;
            this.minutesTens--;
          }
          break;
        case "secondsTens":
          if (this.secondsTens > 0) this.secondsTens--;
          break;
        case "secondsOnes":
          if (this.secondsOnes > 0) this.secondsOnes--;
          else if (this.secondsTens > 0) {
            this.secondsOnes = 9;
            this.secondsTens--;
          }
          break;
      }
    },

    // 开始定时器
    async handleStart() {
      if (this.totalSeconds === 0) return;

      try {
        this.startLoading = true;
        const response = await createTimer({
          room_id: this.roomInfo.id,
          timer_second: this.totalSeconds,
          timer_type: 2,
        });

        if (response.code === 1) {
          this.currentTimerId = response.data.id;
          this.remainingSeconds = this.totalSeconds;
          this.isRunning = true;
          this.isPaused = false;
          this.isFinished = false;
          this.version = response.data.version || 0;

          // 保存调整后的时间（用于页面刷新时回显）
          this.saveTimerData();

          this.startCountdown();

          // 广播通知其他人
          this.broadcastTimerEvent("start", {
            timerId: this.currentTimerId,
            remainingSeconds: this.remainingSeconds, // 同步当前剩余时间
            version: this.version,
          });
        } else {
          this.$darkMessage.error(response.message);
        }
      } catch (error) {
        console.error("创建定时器失败:", error);
        this.$darkMessage.error("创建定时器失败");
      } finally {
        this.startLoading = false;
      }
    },

    // 重新开始
    handleRestart() {
      try {
        this.restartLoading = true;
        if (this.currentTimerId) {
          endTimer({ id: this.currentTimerId }).then((res) => {
            if (res.code === 1) {
              const remainingSeconds = this.remainingSeconds;
              this.stopAlarm();
              this.clearTimer();
              this.isRunning = false;
              this.isPaused = false;
              this.isFinished = false;
              this.currentTimerId = null;
              this.remainingSeconds = 0; // 重置为0，确保显示00:00

              // 重置为上一次开始的时间（从localStorage获取）
              const lastStartTimeData = localStorage.getItem("lastTimerData");
              if (lastStartTimeData) {
                try {
                  const data = JSON.parse(lastStartTimeData);
                  if (data.roomId === this.roomInfo.id) {
                    // 使用上一次开始的时间
                    this.remainingSeconds = data.timerSeconds;
                    this.setTimeFromSeconds(data.timerSeconds);
                  } else {
                    // 不是当前直播间，使用默认时间
                    this.remainingSeconds = this.defaultTimerSeconds;
                    this.setTimeFromSeconds(this.defaultTimerSeconds);
                  }
                } catch (error) {
                  console.error("解析localStorage数据失败:", error);
                  this.remainingSeconds = this.defaultTimerSeconds;
                  this.setTimeFromSeconds(this.defaultTimerSeconds);
                }
              } else {
                // 没有存储数据，使用默认时间
                this.remainingSeconds = this.defaultTimerSeconds;
                this.setTimeFromSeconds(this.defaultTimerSeconds);
              }

              // 广播通知其他人
              this.broadcastTimerEvent("restart", {
                remainingSeconds: remainingSeconds, // 同步重置后的时间
                version: this.version,
              });
            } else {
              this.$darkMessage.error(res.message);
            }
          });
        }
      } catch (error) {
        console.error("重新开始失败:", error);
        this.$darkMessage.error("重新开始失败");
      } finally {
        this.restartLoading = false;
      }
    },

    // 暂停
    async handlePause() {
      try {
        this.pauseLoading = true;
        const response = await pauseTimer({
          id: this.currentTimerId,
          downtime: this.remainingSeconds,
        });

        if (response.code === 1) {
          this.isRunning = false;
          this.isPaused = true;
          this.version = response.data.version || this.version;

          this.clearTimer();

          // 广播通知其他人
          this.broadcastTimerEvent("pause", {
            timerId: this.currentTimerId,
            remainingSeconds: this.remainingSeconds, // 同步当前剩余时间
            version: this.version,
          });
        } else {
          this.$darkMessage.error(response.message);
        }
      } catch (error) {
        console.error("暂停失败:", error);
        this.$darkMessage.error("暂停失败");
      } finally {
        this.pauseLoading = false;
      }
    },

    // 继续
    async handleContinue() {
      try {
        this.continueLoading = true;
        const response = await startTimer({ id: this.currentTimerId });

        if (response.code === 1) {
          this.isRunning = true;
          this.isPaused = false;
          this.version = response.data.version || this.version;

          this.startCountdown();

          // 广播通知其他人
          this.broadcastTimerEvent("continue", {
            timerId: this.currentTimerId,
            remainingSeconds: this.remainingSeconds, // 同步当前剩余时间
            version: this.version,
          });
        } else {
          this.$darkMessage.error(response.message);
        }
      } catch (error) {
        console.error("继续失败:", error);
        this.$darkMessage.error("继续失败");
      } finally {
        this.continueLoading = false;
      }
    },

    // 开始倒计时
    startCountdown() {
      this.clearTimer();

      // 设置结束时间戳，确保精度
      this.endTimestamp = Date.now() + this.remainingSeconds * 1000;

      console.log(
        "开始倒计时，结束时间戳:",
        new Date(this.endTimestamp),
        "剩余时间:",
        this.remainingSeconds
      );

      // 使用精确计时器，每秒执行一次
      this.accurateTimer = new AccurateTimer(
        (timeDiff) => {
          // 基于时间戳计算当前应该显示的剩余时间
          const now = Date.now();
          const remainingTime = Math.max(0, this.endTimestamp - now);
          const currentRemainingSeconds = Math.ceil(remainingTime / 1000);

          // 更新显示时间
          this.remainingSeconds = Math.max(0, currentRemainingSeconds);

          if (this.remainingSeconds <= 0) {
            // 倒计时完成
            this.clearTimer();
            this.isRunning = false;
            this.isPaused = false;
            this.isFinished = true;
            this.remainingSeconds = 0;

            // 播放闹铃
            this.playAlarm();

            // 自动调用结束接口
            // this.handleTimerFinished();

            // 广播通知其他人
            this.broadcastTimerEvent("finished", {
              timerId: this.currentTimerId,
              remainingSeconds: this.remainingSeconds, // 同步结束时间
              version: this.version,
            });
          }
          // 倒计时进行中，remainingSeconds会自动更新，计算属性会自动重新计算
        },
        1000, // 每秒执行一次
        {
          immediate: false, // 不立即执行第一次
          vueInstance: this, // 绑定Vue实例，自动清理
        }
      );

      // 启动精确计时器
      this.accurateTimer.start();

      // 启动同步定时器，每分钟同步一次时间
      this.startSyncTimer();
    },

    // 清除定时器
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      // 清理精确计时器
      if (this.accurateTimer) {
        this.accurateTimer.stop();
        this.accurateTimer = null;
      }
      // 清理同步定时器
      this.clearSyncTimer();
    },

    // 播放闹铃
    playAlarm() {
      if (this.alarmAudio) {
        this.alarmAudio.play().catch((error) => {
          console.error("播放闹铃失败:", error);
        });
      }
    },

    // 停止闹铃
    stopAlarm() {
      if (this.alarmAudio) {
        this.alarmAudio.pause();
        this.alarmAudio.currentTime = 0;
      }
    },

    // 启动同步定时器
    startSyncTimer() {
      // 清除之前的同步定时器
      this.clearSyncTimer();

      // 记录开始同步的时间
      this.lastSyncTime = Date.now();

      // 每分钟同步一次时间
      this.syncTimerId = setInterval(() => {
        this.syncTimerTime();
      }, 60000); // 60秒 = 1分钟
    },

    // 清理同步定时器
    clearSyncTimer() {
      if (this.syncTimerId) {
        clearInterval(this.syncTimerId);
        this.syncTimerId = null;
      }
    },

    // 同步定时器时间
    async syncTimerTime() {
      if (!this.isRunning || !this.currentTimerId) {
        return;
      }

      try {
        console.log("开始同步定时器时间，当前剩余时间:", this.remainingSeconds);

        // 使用getToolbox接口查询当前状态，而不是pauseTimer
        const response = await getToolbox({
          room_id: this.roomInfo.id,
        });

        if (response.code === 1 && response.data) {
          // 查找当前计时器的状态
          const timerData = response.data.countdown;

          if (timerData) {
            // 更新版本号
            if (timerData.timer_state === 1) {
              // 运行中
              this.elapsedSeconds =
                timerData.timer_second -
                (parseInt(response.serverTime / 1000) -
                  timerData.start_time -
                  timerData.total_downtime);
            }
          } else {
            console.log("未找到对应的计时器数据");
          }
        } else {
          console.error("获取工具箱状态失败:", response.message);
        }
      } catch (error) {
        console.error("同步定时器时间失败:", error);
      }
    },

    // 处理定时器结束
    async handleTimerFinished() {
      try {
        if (this.currentTimerId && !this.isStudent) {
          endTimer({ id: this.currentTimerId }).then((res) => {
            if (res.code === 1) {
              // 重置状态
              this.currentTimerId = null;
              this.version = 0;
              this.remainingSeconds = 0;
            } else {
              this.$darkMessage.error(res.message);
            }
          });
        }
      } catch (error) {
        console.error("结束定时器失败:", error);
        this.$darkMessage.error("结束定时器失败");
      }
    },

    // 广播定时器事件
    broadcastTimerEvent(event, data) {
      if (this.imService) {
        this.imService.sendMGLiveRoomCustomMsg({
          cmdId: 2,
          data: {
            type: "timeout",
            data: {
              event: event,
              ...data,
              roomId: this.roomInfo.id,
            },
          },
        });
      }
    },

    // 处理IM消息监听
    handleImListener() {
      if (this.imService) {
        this.imService.on(
          "recvMGLiveRoomCustomMsg",
          this.handleLiveRoomCustomMsg
        );
      }
    },

    // 移除IM消息监听
    removeImListener() {
      if (this.imService) {
        this.imService.off(
          "recvMGLiveRoomCustomMsg",
          this.handleLiveRoomCustomMsg
        );
      }
    },

    // 处理直播间自定义消息
    handleLiveRoomCustomMsg(res) {
      console.log("djj_handleLiveRoomCustomMsg__", res);

      if (res.data && res.data.type === "timeout") {
        console.log("djj_handleLiveRoomCustomMsg__", res.data.data);
        const timerData = res.data.data;
        this.handleTimerEvent(timerData.event, timerData);
      }
    },

    // 检查是否应该处理消息
    shouldProcessMessage(event, data) {
      console.log("shouldProcessMessage___", event);
      console.log("shouldProcessMessage___data", data);
      console.log("shouldProcessMessage___version", this.version);
      console.log("shouldProcessMessage___currentTimerId", this.currentTimerId);

      // 定时器ID比对逻辑
      if (this.currentTimerId && data.timerId) {
        // 两个都存在，进行比对
        if (data.timerId < this.currentTimerId) {
          console.log("忽略旧定时器的消息");
          return false;
        }
        if (data.timerId > this.currentTimerId) {
          // 新定时器，重置版本号
          this.version = 0;
        }
      } else if (!this.currentTimerId && data.timerId) {
        // 当前没有定时器ID，但收到的消息有定时器ID，代表新定时器
        console.log("收到新定时器消息，重置版本号");
        this.version = 0;
      }

      // 再比对版本号
      if (data.version && data.version < this.version) {
        console.log("忽略旧版本的消息");
        return false;
      }
      this.version = data.version;
      return true;
    },

    // 处理接收到的定时器事件
    handleTimerEvent(event, data) {
      console.log("收到定时器事件:", event, data);

      // 检查是否应该处理消息
      if (!this.shouldProcessMessage(event, data)) {
        return;
      }

      switch (event) {
        case "start":
          this.currentTimerId = data.timerId;
          // 使用remainingSeconds同步时间
          this.remainingSeconds =
            data.remainingSeconds !== undefined ? data.remainingSeconds : 0;
          console.log("开始定时器，同步剩余时间:", this.remainingSeconds);
          this.isRunning = true;
          this.isPaused = false;
          this.setDialogStatus(true);
          this.startCountdown();
          break;
        case "pause":
          this.isRunning = false;
          this.isPaused = true;
          this.setDialogStatus(true);
          this.clearTimer();
          // 同步接收到的当前剩余时间
          if (data.remainingSeconds !== undefined) {
            this.remainingSeconds = data.remainingSeconds;
            console.log("暂停定时器，同步剩余时间:", this.remainingSeconds);
          }
          break;
        case "continue":
          this.isRunning = true;
          this.isPaused = false;
          this.setDialogStatus(true);
          // 同步接收到的当前剩余时间
          if (data.remainingSeconds !== undefined) {
            this.remainingSeconds = data.remainingSeconds;
            console.log("继续定时器，同步剩余时间:", this.remainingSeconds);
          }
          this.startCountdown();
          break;
        case "restart":
          this.clearTimer();
          this.isRunning = false;
          this.isPaused = false;
          this.isFinished = false;
          this.setDialogStatus(false);
          this.currentTimerId = null;
          // 同步接收到的重置时间
          this.remainingSeconds =
            data.remainingSeconds !== undefined ? data.remainingSeconds : 0;
          console.log("重新开始定时器，同步剩余时间:", this.remainingSeconds);
          break;
        case "finished":
          this.clearTimer();
          this.isRunning = false;
          this.isPaused = false;
          this.isFinished = true;
          // 同步接收到的结束时间
          this.remainingSeconds =
            data.remainingSeconds !== undefined ? data.remainingSeconds : 0;
          console.log("定时器结束，同步剩余时间:", this.remainingSeconds);
          this.playAlarm();
          break;
        case "close":
          this.clearTimer();
          this.isRunning = false;
          this.isPaused = false;
          this.isFinished = false;
          this.setDialogStatus(false);
          // 同步接收到的关闭时间
          this.remainingSeconds =
            data.remainingSeconds !== undefined ? data.remainingSeconds : 0;
          console.log("关闭定时器，同步剩余时间:", this.remainingSeconds);
          break;
        case "sync":
          // 处理同步事件
          if (data.remainingSeconds !== undefined) {
            this.remainingSeconds = data.remainingSeconds;
            // 重新计算结束时间戳
            this.endTimestamp = Date.now() + this.remainingSeconds * 1000;
            console.log("收到同步事件，更新剩余时间:", this.remainingSeconds);
          }
          break;
      }
      console.log("djj_visible__listenrr", this.compVisible);
    },

    // 关闭弹窗
    async handleClose() {
      this.stopAlarm();
      this.clearTimer();
      // 如果正在运行或暂停，调用结束接口
      if (this.currentTimerId) {
        try {
          const timerId = this.currentTimerId;
          const version = this.version;
          endTimer({ id: timerId }).then((res) => {
            if (res.code === 1) {
              this.currentTimerId = null;
              this.version = 0;
              this.remainingSeconds = 0;
              // 广播通知其他人
              this.broadcastTimerEvent("close", {
                timerId: timerId,
                remainingSeconds: 0, // 同步关闭后的时间
                version: version,
              });
              this.setDialogStatus(false);
            } else {
              this.$darkMessage.error(res.message);
            }
          });
        } catch (error) {
          this.$darkMessage.error("结束定时器失败");
          console.error("结束定时器失败:", error);
        }
      } else {
        // 广播通知其他人
        this.broadcastTimerEvent("close", {
          timerId: this.currentTimerId,
          remainingSeconds: 0, // 同步关闭后的时间
          version: this.version,
        });
        this.setDialogStatus(false);
      }
    },
    // 设置弹窗开关
    setDialogStatus(val) {
      this.compVisible = val;
      if (!this.isStudent) {
        this.setShowToolbox({
          timeout: val,
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.timer-container {
  width: 327px;
  background: #18181b;
  border: 2px solid #27272a;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  padding: 20px 16px 0px;
  position: relative;
}
.timer-container_student {
  padding-top: 10px;
  .timer-footer {
    padding: 0 0 10px 0;
  }
  .timer-content {
    height: 100px;
  }
}

.timer-header {
  display: flex;
  align-items: center;
  justify-content: center;

  margin-bottom: 12px;

  .title {
    font-family: PingFang SC;
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
    color: #c9cdd4;
  }

  .close {
    position: absolute;
    right: 14px;
    top: 14px;
    width: 24px;
    height: 24px;
    cursor: pointer;

    img {
      width: 24px;
      height: 24px;
    }
  }
}

.timer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 8px;
}

.time-display {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 274px;
  height: 130px;
}

.time-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  .time-box {
    width: 53px;
    height: 82px;
    background: #e8f3ff;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;

    .time-number {
      font-family: DIN Alternate;
      font-weight: 700;
      font-size: 64px;
      line-height: 75px;
      color: #165dff;

      &.warning {
        color: #f53f3f;
      }

      &.danger {
        color: #f53f3f;
      }
    }
  }

  .arrow-up,
  .arrow-down {
    width: 24px;
    height: 24px;
    cursor: pointer;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    transition: all 0.2s;

    &:hover {
      transform: scale(1.1);
    }
  }

  .arrow-up {
    background-image: url("../../../assets/images/live/arrow-up-default.png");

    &:hover {
      background-image: url("../../../assets/images/live/arrow-up-hover.png");
    }
  }

  .arrow-down {
    background-image: url("../../../assets/images/live/arrow-up-default.png");
    transform: rotate(180deg);

    &:hover {
      background-image: url("../../../assets/images/live/arrow-up-hover.png");
      transform: rotate(180deg);
    }
  }
}

.separator {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin: 0 8px;

  .dot {
    width: 10px;
    height: 10px;
    background: #bedaff;
    border-radius: 50%;
  }
}

.timer-footer {
  display: flex;
  gap: 8px;
  padding: 16px 0;

  .action-btn {
    flex: 1;
    height: 40px;
    border-radius: 12px;
    font-weight: 600;
    font-size: 14px;

    &.el-button--primary {
      background: #0e42d2;
      border-color: #0e42d2;

      &:hover {
        background: #165dff !important;
        border-color: #165dff !important;
      }
    }

    &.el-button--default {
      background: #27272a;
      border-color: #27272a;
      color: #ffffff;

      &:hover {
        background: #3a3a3d;
        border-color: #3a3a3d;
      }
    }
  }
  .pause-tips {
    width: 100%;
    height: 28px;
    text-align: center;
    font-weight: 400;
    font-size: 18px;
    color: #c9cdd4;
    line-height: 28px;
    text-align: center;
  }
}
</style>
